import type { StatItem, Task } from '@/types';
import { ColumnFilter } from '@tanstack/vue-table';
import { defineStore } from 'pinia';

export type DashboardState = {
    tasks: Task[];
    procedureCount: number;
    isTasksLoading: boolean;
    isProceduresLoading: boolean;
    activeFilterKey: string;
    activeFilter: ColumnFilter;
};

export const useDashboardStore = defineStore('dashboard', {
    state: (): DashboardState => ({
        tasks: [],
        procedureCount: 0,
        isTasksLoading: true,
        isProceduresLoading: true,
        activeFilterKey: '',
        activeFilter: { id: '', value: [] },
    }),
    getters: {
        taskCount: (state) => state.tasks.length,
        uniqueWorkDays: (state) => {
            const uniqueDays = new Set<string>();
            state.tasks.forEach((task) => {
                if (task.weekdaysData) {
                    task.weekdaysData.forEach((day) => uniqueDays.add(day));
                }
            });

            const weekOrder = [
                'monday',
                'tuesday',
                'wednesday',
                'thursday',
                'friday',
                'saturday',
                'sunday',
            ];

            return Array.from(uniqueDays).sort(
                (a, b) => weekOrder.indexOf(a) - weekOrder.indexOf(b),
            );
        },
    },
    actions: {
        setTasks(tasks: Task[]) {
            this.tasks = tasks;
            this.isTasksLoading = false;
        },
        setProcedureCount(count: number) {
            this.procedureCount = count;
            this.isProceduresLoading = false;
        },
        setTasksLoading(loading: boolean) {
            this.isTasksLoading = loading;
        },
        setProceduresLoading(loading: boolean) {
            this.isProceduresLoading = loading;
        },
        resetActiveFilter() {
            this.activeFilterKey = '';
            this.activeFilter = { id: '', value: [] };
        },
        setActiveFilter(item: StatItem) {
            this.activeFilterKey = item.key;
            this.activeFilter = item.filter;
        },
    },
});
